import styled from 'styled-components'

import { _S_Bold, _S_Normal, mainColors, semanticColors } from '@avantstay/backoffice-core'

export const Root = styled.section`
  border: 1px solid ${semanticColors.failureLight};
  border-left: 3px solid ${semanticColors.failureDark};
  border-radius: 12px;
  background: ${semanticColors.failureExtraLight};
  margin-bottom: 12px;
`

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  color: ${semanticColors.failureDark};

  svg {
    width: 16px;
    height: 16px;
    flex: none;
  }
`

export const Headline = styled.span`
  ${_S_Bold};
  color: ${semanticColors.failureDark};
  overflow-wrap: anywhere;
`

export const Facts = styled.div`
  display: grid;
  gap: 8px;
  padding: 0 12px 12px;
`

export const Fact = styled.div`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark2};
  line-height: 1.5;
  overflow-wrap: anywhere;
`

export const FactTitle = styled.b`
  ${_S_Bold};
  color: ${mainColors.primaryMedium};
`
